var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.71279 3.63912e-05H27.7891C31.7154 -0.0123546 34.9085 3.14114 34.9212 7.04373V16.9562C34.9085 20.8588 31.7154 24.0123 27.7891 23.9999H7.71279C3.78649 24.0123 0.593411 20.8588 0.580688 16.9562V7.04373C0.593411 3.14114 3.78649 -0.0123546 7.71279 3.63912e-05ZM13.5754 16.9066L22.9659 12.48L22.9654 12.4821C23.0936 12.4205 23.1758 12.292 23.1775 12.1504C23.1792 12.0089 23.1001 11.8785 22.9734 11.8138L13.5834 7.11413C13.4669 7.05462 13.3277 7.05971 13.2159 7.12756C13.1042 7.19541 13.036 7.31622 13.0361 7.44639V16.5706C13.0361 16.6991 13.1027 16.8186 13.2122 16.8869C13.3218 16.9552 13.459 16.9626 13.5754 16.9066Z","fill":"#9D4DBD"}));
}

Youtube.defaultProps = {"width":"35","height":"24","viewBox":"0 0 35 24","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
